import { NgModule } from '@angular/core';

import { AccessCtrlInvDirective } from './access-ctrl-inv.directive';
import { AccessCtrlDirective } from './access-ctrl.directive';
import { BrandAccessCtrlDirective } from './brand-access-ctrl.directive';
import { BrandRolesAccessCtrlDirective } from './brand-roles-access-ctrl.directive';
import { HotjarEventDirective } from './hotjar-event.directive';
import { ShowAccountTypesDirective } from './show-account-types.directive';
import { ShowForBrandDirective } from './show-for-brand.directive';
import { ShowOxioAdminAsBrandDirective } from './show-oxio-admin-as-brand.directive';
import { ShowOxioAdminDirective } from './show-oxio-admin.directive';

@NgModule({
  declarations: [
    AccessCtrlDirective,
    AccessCtrlInvDirective,
    BrandAccessCtrlDirective,
    ShowAccountTypesDirective,
    ShowOxioAdminDirective,
    BrandRolesAccessCtrlDirective,
    HotjarEventDirective,
    ShowForBrandDirective,
    ShowOxioAdminAsBrandDirective
  ],
  exports: [
    AccessCtrlDirective,
    AccessCtrlInvDirective,
    BrandAccessCtrlDirective,
    ShowOxioAdminDirective,
    ShowAccountTypesDirective,
    BrandRolesAccessCtrlDirective,
    HotjarEventDirective,
    ShowForBrandDirective,
    ShowOxioAdminAsBrandDirective
  ],
  providers: [],
  imports: [],
})
export class DirectivesModule {}
